import React, { useState } from 'react';
import { LockSimple, X, SignIn, Eye } from '@phosphor-icons/react';
import { useAuth } from '@/context/AuthContext';

export const AnonymousInteractionGate = ({ children }) => {
  const { isAuthenticated, openAuthModal } = useAuth();
  const [showNotice, setShowNotice] = useState(false);

  const handleIntercept = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      e.stopPropagation();
      setShowNotice(true);
    }
  };

  return (
    <div className="relative w-full h-full flex-1 flex flex-col min-h-0">
      {/* Protected Operational Content */}
      <div
        className="w-full h-full flex-1 flex flex-col min-h-0"
        inert={!isAuthenticated ? "" : undefined}
        aria-hidden={!isAuthenticated}
      >
        {children}
      </div>

      {/* Global Transparent Interaction Shield for Anonymous Users */}
      {!isAuthenticated && (
        <div
          onClick={handleIntercept}
          onKeyDown={handleIntercept}
          data-testid="anonymous-interaction-shield"
          className="absolute inset-0 z-30 cursor-pointer bg-black/10 backdrop-blur-[0.5px] transition-all"
          title="Modo Vista Previa — Inicia sesión para interactuar"
        >
          {/* Subtle floating Preview Badge at bottom-center */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-[#13131A]/95 border border-[#00E5FF]/30 text-[#00E5FF] px-3 py-1.5 rounded-full shadow-2xl flex items-center gap-2 text-xs font-mono select-none pointer-events-none">
            <Eye size={14} className="animate-pulse text-[#00E5FF]" />
            <span className="font-bold">PREVIEW MODE</span>
            <span className="text-[#9CA3AF] text-[11px]">— Clic para iniciar sesión</span>
          </div>
        </div>
      )}

      {/* Authentication Required Modal (Triggered on background click) */}
      {!isAuthenticated && showNotice && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="auth-gate-title"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-xs p-4 animate-in fade-in duration-200"
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowNotice(false);
          }}
        >
          <div
            data-testid="auth-gate-notice"
            className="w-full max-w-md bg-[#13131A] border border-[#00E5FF]/40 rounded-xl shadow-[0_0_50px_rgba(0,0,0,0.8)] p-6 space-y-5 text-center font-mono relative"
          >
            <button
              onClick={() => setShowNotice(false)}
              className="absolute top-4 right-4 p-1 text-[#9CA3AF] hover:text-white hover:bg-[#1F2937] rounded transition-colors"
              title="Cerrar"
            >
              <X size={16} />
            </button>

            <div className="w-14 h-14 rounded-full bg-[#00E5FF]/10 border border-[#00E5FF]/30 flex items-center justify-center text-[#00E5FF] mx-auto shadow-[0_0_20px_rgba(0,229,255,0.2)]">
              <LockSimple size={28} weight="bold" />
            </div>

            <div className="space-y-2">
              <h2 id="auth-gate-title" className="text-base font-bold text-white tracking-wide uppercase">
                AUTHENTICATION REQUIRED
              </h2>
              <p className="text-xs text-[#9CA3AF] leading-relaxed">
                Para utilizar AI Bridge Hub y operar proyectos, conectores, sesiones y herramientas de orquestación, inicia sesión o crea una cuenta.
              </p>
            </div>

            <div className="pt-2 space-y-2">
              <button
                type="button"
                data-testid="auth-gate-signin-btn"
                onClick={() => {
                  setShowNotice(false);
                  openAuthModal();
                }}
                className="w-full py-2.5 px-4 bg-[#00E5FF] hover:bg-[#00E5FF]/90 text-[#0A0C10] font-bold text-xs rounded shadow-lg transition-all flex items-center justify-center gap-2"
              >
                <SignIn size={16} weight="bold" />
                <span>Sign In / Register</span>
              </button>

              <button
                type="button"
                data-testid="auth-gate-dismiss-btn"
                onClick={() => setShowNotice(false)}
                className="w-full py-2 text-xs text-[#9CA3AF] hover:text-white transition-colors"
              >
                Continuar en Modo Vista Previa
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnonymousInteractionGate;
